export default __webpack_public_path__ + "static/media/kitchen4-afterA-768w.930d7ad2.png";